
import { DeploymentInstanceRepository } from '../repositories/DeploymentInstanceRepository';

export class DeploymentInstanceService {
  private repository: DeploymentInstanceRepository;

  constructor() {
    this.repository = DeploymentInstanceRepository.getInstance();
  }

  /**
   * Get all models
   */
  public async getDeploymentInstances(): Promise<any> {
    return await this.repository.getDeploymentInstances();
  }

  public async getDeploymentInstanceById(id: any): Promise<any> {
    return await this.repository.getDeploymentInstanceById(id);
  }

  public async deleteDeploymentInstanceById(id: any,model_name: string): Promise<any> {
    return await this.repository.deleteDeploymentInstanceById(id, model_name);
  }

  public async deploymentInstance(id: any): Promise<any> {
    return await this.repository.deploymentInstance(id);
  }

  public async startInstance(id: any): Promise<any> {
    return await this.repository.startInstance(id);
  }

  public async stopInstance(id: any): Promise<any> {
    return await this.repository.stopInstance(id);
  }

  public async restartInstance(id: any): Promise<any> {
    return await this.repository.restartInstance(id);
  }

  public async deploymentInstancesConfigsById(id: any): Promise<any> {
    return await this.repository.deploymentInstancesConfigsById(id);
  }
  
}

// Export singleton instance
export const deploymentInstanceService = new DeploymentInstanceService();
